import { eventMenuItemClicked } from './cam-context-switcher-constants';
import '../../scripts/global-menu-generic-icon';
import chevronIcon from '../../assets/images/icons/chevron-right.svg';

const tagName = 'cam-context-switcher-menu-item';
const template = require(`../templates/${tagName}.ejs`);

export default class CamContextSwitcherMenuItem extends HTMLElement {

  constructor(menuitemData) {
    super();
    this.menuitemData = menuitemData;
    this.onclick = this.handleClick;
  }

  connectedCallback() {
    this.classList.add(tagName);

    this.innerHTML = template(this.menuitemData);
    if (this.menuitemData.display.selected) {
      this.firstChild.classList.add('selected');
      this.firstChild.innerHTML += chevronIcon;
    }
  }

  handleClick() {
    let eventOptions = {
      detail: {
        context: this.menuitemData.context
      },
      bubbles: true,
      cancelable: true
    };
    this.dispatchEvent(new CustomEvent(eventMenuItemClicked, eventOptions));
  }


}

if (!customElements.get(tagName)) {
  customElements.define(tagName, CamContextSwitcherMenuItem);
}



// WEBPACK FOOTER //
// ./src/cam-context-switcher/scripts/cam-context-switcher-menu-item.js